import { BUTTON_WIDTH } from "../../constants/constants";

/**
 * Gets the width of the left charms container.
 * @param searchAlignmentWidth - The width of the search alignment container.
 * @param leadingControlsWidth - The rendered width of controls before the alignment container.
 * @returns The width of the left charms container in pixels.
 */
export default function getLeftCharmsContainerWidth(searchAlignmentWidth: number, leadingControlsWidth: number = BUTTON_WIDTH): number {
    return Math.max(0, searchAlignmentWidth - leadingControlsWidth);
}
